module.exports = __webpack_public_path__ + "static/media/contact.8ed5f3cd.svg";